import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { PageService } from '@modules/shared/services/page.service';
import { PageActions } from '@store/actions/page.actions';
import { CreatePageRequest, UpdatePageRequest } from '@models/page.model';

@Injectable()
export class PageEffects {
  private readonly actions$ = inject(Actions);
  private readonly pageService = inject(PageService);

  getPages$ = createEffect(() => this.actions$.pipe(
      ofType(PageActions.GET_PAGES),
      exhaustMap(({payload}: { payload: string }) => this.pageService.getAll(payload || undefined)
        .pipe(
          map(payload => ({type: PageActions.GET_PAGES_SUCCESS, payload})),
          catchError(error => of(({type: PageActions.GET_PAGES_FAILED, error}))),
        )),
    ),
  );

  updatePage$ = createEffect(() => this.actions$.pipe(
      ofType(PageActions.UPDATE_PAGE),
    exhaustMap(({webshopId, payload}: {
      webshopId: string,
        payload: UpdatePageRequest
    }) => {
      return this.pageService.update(webshopId, payload)
        .pipe(
          map(payload => ({type: PageActions.UPDATE_PAGE_SUCCESS, payload})),
          catchError(error => of(({type: PageActions.UPDATE_PAGE_FAILED, error}))),
        );
    }),
    ),
  );

  createPage$ = createEffect(() => this.actions$.pipe(
      ofType(PageActions.CREATE_PAGE),
    exhaustMap(({webshopId, payload}: {
      webshopId: string,
        payload: CreatePageRequest
    }) => this.pageService.create(webshopId, payload)
        .pipe(
          map(payload => ({type: PageActions.CREATE_PAGE_SUCCESS, payload})),
          catchError(error => of(({type: PageActions.CREATE_PAGE_FAILED, error}))),
        )),
    ),
  );

  deletePage$ = createEffect(() => this.actions$.pipe(
      ofType(PageActions.DELETE_PAGE),
    exhaustMap(({webshopId, pageId}: {
      webshopId: string, pageId: string
    }) => this.pageService.delete(webshopId, pageId)
        .pipe(
          map(() => ({type: PageActions.DELETE_PAGE_SUCCESS, payload: pageId})),
          catchError(error => of(({type: PageActions.DELETE_PAGE_FAILED, error}))),
        )),
    ),
  );
}
